import { NgModule } from "@angular/core";
import { LoginPageComponent } from "./components/login/login.component";

@NgModule({
  declarations: [LoginPageComponent],
  imports: [],
  exports: [LoginPageComponent],
})
export class AuthModule {}
